import appReducer from './appReducers';
import dataReducer from './dataReducers';
import registerLive from './live';
import operations from './operations';
import operationsResponsive from './operationsResponsive';
import * as selectors from './selectors';
import * as selectorsResponsive from './selectorsResponsive';

const conversations = (services) => {
  const protoDuck = {
    appReducer,
    dataReducer,
    operations: operations(services),
    operationsResponsive: operationsResponsive(services),
    selectors,
    selectorsResponsive,
  };

  return {
    ...protoDuck,
    registerLive: registerLive(protoDuck.operations),
  };
};

export default conversations;
